<template>
  <div class="banquet-result">
    <div v-if="this.orderStatus.payStatus !== undefined">
      <div v-if="this.orderStatus.payStatus === 10" class="banquet-apply-success">
        <img
          src="~@/assets/images/success.svg"
          v-if="this.orderStatus.payStatus === 10"
        />
        <img src="~@/assets/images/processing.svg" v-else />
        <div class="banquet-apply-success-text">{{ bookingStatus }}</div>
        <div class="banquet-apply-success-order-id">
          {{ `訂單編號：${orderStatus.orderId}` }}
        </div>
      </div>
      <div v-else class="banquet-apply-success">
        <img src="~@/assets/images/failure.svg" />
        <div class="banquet-apply-success-text">申請失敗</div>
        <div class="banquet-apply-success-order-id">
          付款失敗
        </div>
      </div>
    </div>
    <div v-else class="banquet-apply-success">
      <img src="~@/assets/images/processing.svg" />
      <div class="banquet-apply-success-text">資料查詢中</div>
      <div class="banquet-apply-success-order-id">
        {{ `訂單編號：${orderStatus.orderId}` }}
      </div>
    </div>
    <div class="banquet-query-record">
      <div class="temple-button-text" @click="clickQueryRecord">
        查詢已申請紀錄
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ServiceBanquetStep4',
  props: {
    orderStatus: {},
  },
  computed: {
    bookingStatus() {
      switch (this.orderStatus.payStatus) {
        case 0:
        case 1:
          return '等待付款中';

        case 10:
          return '申請成功';

        default:
          return '申請失敗';
      }
    },
  },
  methods: {
    clickQueryRecord() {
      this.$router.push({ path: '/service?page=3' });
    },
  },
};
</script>

<style scoped>
.banquet-result {
  margin: 0px 5px 0px 5px;
}

.banquet-apply-success {
  margin: 100px 0px 100px 0px;
  align-items: center;
  text-align: center;
}

.banquet-apply-success-text {
  margin: 5px 0px 5px 0px;
  font-size: 12px;
  color: #000000;
}

.banquet-apply-success-order-id {
  font-size: 16px;
  font-weight: bold;
  color: #000000;
}

.banquet-query-record {
  margin-top: 50px;
  align-items: center;
  display: flex;
  justify-content: center;
}

@media (min-width: 768px) {
  .banquet-apply-success-order-id {
    margin-top: 20px;
  }
}
</style>
